import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface StatsShimmerProps {
  /**
   * Number of stat boxes to display
   * @default 4
   */
  count?: number;
}

/**
 * A shimmer loading component for stats boxes that mimics the actual stats layout
 */
export const StatsShimmer = ({ count = 4 }: StatsShimmerProps) => (
  <div className="flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white sm:flex-row">
    {Array.from({ length: count }).map((_, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={cn(
          "flex min-w-0 flex-1 items-center justify-between gap-3 px-4 py-3",
          index < count - 1 && "border-b border-gray-200 sm:border-b-0 sm:border-r",
        )}
      >
        <div className="flex min-w-0 items-center gap-2">
          <Skeleton width="16px" height="16px" borderRadius="4px" className="shrink-0" />
          <Skeleton width="90px" height="14px" />
        </div>
        <Skeleton width="48px" height="14px" className="shrink-0" />
      </div>
    ))}
  </div>
);

export default StatsShimmer;
